export default __webpack_public_path__ + "static/media/icon_schedule_circle.afd2d134.svg";